/**
 * @ngdoc  service
 * @module csm.ng
 * @name   csm.ng.CompileService.service:CompilerService
 *
 * @description
 *   Utilities for compilation of AngularJS objects.
 **/
/* @ngInject */
export function compilerService($injector) {
  var $svcs = { $svc: this };
  this.transcludeSlots = $injector.invoke(transcludeSlots, this, $svcs);
}

/**
 * @ngdoc    method
 * @name     transcludeSlots
 * @methodOf csm.ng.CompileService.service:CompilerService
 *
 * @param {object} element     Component/Directive instance element.
 * @param {object} scope       Properties to set in transclusion scope.
 * @param {object} $transclude Tranclusion service/function.
 *
 * @description
 * Helper method for manual, multi-slot, transclusion where properties from the
 * parent scope may be passed to the transclusion scope. The transclusion scope
 * is not a child of the element scope, but rather, is a child of element parent
 * scope. Properties passed in `scope` (such as a reference to the `element`
 * controller) are copied to the transclusion scope.
 *
 * Transclusion insertion points in `element` are marked with
 * `<csm-ng-transclude slot="slotName">` elements or any element with the
 * `csm-ng-transclude-slot="slotName"` attribute.
 *
 * NOTE: We can't use `ng-transclude="slotName"` or `ng-transclude-slot="slotName"
 * as this is the automated transclusion process and will result in double
 * transclusion. Don't know how to prevent the default.
 *
 * See: {@link https://docs.angularjs.org/api/ng/service/$compile#transclusion AngularJS Transclusion}
 * See: {@link http://angular-tips.com/blog/2014/03/transclusion-and-scopes/   Transclusion and Scopes}
 **/

/* @ngInject */
function transcludeSlots() {
  return function (element, scope, $transclude) {
    /*-------------------------------------------------*/
    /* Find the transclusion insertion point elements. */
    /*-------------------------------------------------*/
    var selectors =
      'csm-ng-transclude[slot]:not([slot=""]), [csm-ng-transclude-slot]:not([csm-ng-transclude-slot=""])';
    var targets = Array.prototype.slice
      .call(element[0].querySelectorAll(selectors))
      .reduce(function (o, e) {
        o[e.getAttribute('slot') || e.getAttribute('csm-ng-transclude-slot')] =
          angular.element(e);
        return o;
      }, {});

    /*-------------------------------------------------*/
    /* Transclude content to insertion points.         */
    /*                                                 */
    /* Note: This will break if AngularJS changes its  */
    /* internal structure of the $transclude function. */
    /*-------------------------------------------------*/
    for (var slot in $transclude.$$boundTransclude.$$slots) {
      if ($transclude.isSlotFilled(slot))
        if (targets[slot])
          $transclude(
            function (clone, tscope) {
              Object.assign(tscope, scope || {});
              targets[slot].empty().append(clone);
            },
            null,
            slot
          );
        else
          throw "Error: [csm.ng.CompilerService.transcludeSlots] Transclusion slot '{0}' element not found.".format(
            slot
          );
    }
  };
}
